import type { Messages } from './messages.en';

export const de: Messages = {
  'home.title': 'L’Infiltré',
  'home.subtitle': 'Krise im Viertel. Wähle einen Modus.',
  'home.resume.eyebrow': 'Fortsetzen',
  'home.resume.label': 'Gespeichertes Spiel fortsetzen',
  'home.standalone.eyebrow': 'Lokal',
  'home.standalone.label': 'Auf diesem Gerät spielen',
  'home.standalone.description': 'Funktioniert offline. Ein Gerät, mehrere Spieler.',
  'home.online.eyebrow': 'Online',
  'home.online.label': 'Privater Raum',
  'home.online.description': 'Demnächst verfügbar.',
  'home.version': 'v0.0.0',
  'home.players_minutes': '3–12 Spieler · 5 Min / Runde',
  'home.eyebrow': 'Krise · Infiltrés bei den Flics',
  'home.lede':
    'Die Flics teilen ein Codewort. Ein Infiltré sieht ein ähnliches — aber anderes — Wort. Enttarne ihn, bevor er dich überführt.',
  'home.tagline.same_word': 'Gleiches Codewort. Fast.',
  'home.tagline.almost': 'Einer von euch ist infiltriert.',
  'home.tagline.spot_the_imposter': 'Finde den Infiltré.',
  'home.rules.cta': 'Spielregeln',

  'rules.eyebrow': 'Briefing · 30 Sekunden',
  'rules.title': 'Spielregeln',
  'rules.sub': 'Drei Regeln. Ein Infiltré. Lass dich nicht erwischen.',
  'rules.step1.title': 'Jeder Spieler bekommt ein geheimes Wort.',
  'rules.step1.body':
    'Die Flics teilen ein Codewort. Der Infiltré sieht ein ähnliches — aber anderes — Wort. Der Clochard sieht nichts: ein Streuner aus dem Viertel, der nur raten kann.',
  'rules.step2.title': 'Beschreibt euer Wort der Reihe nach.',
  'rules.step2.body':
    'Ein Wort, keine Reime, kein Buchstabieren. Bluffer müssen improvisieren, ohne sich zu verraten.',
  'rules.step3.title': 'Stimmt gegen den Infiltré.',
  'rules.step3.body':
    'Nach den Hinweisen wird abgestimmt. Wenn der Clochard rausgewählt wird, darf er einmal das Wort der Flics raten und den Sieg stehlen.',
  'rules.footer': 'Am besten mit 4–8 Freunden. Reicht das Gerät weiter. Vertraut niemandem.',
  'rules.got_it': 'Verstanden',

  'setup.count.heading': 'Wie viele Spieler?',
  'setup.count.hint': 'Tippe die Zahl, dann gib das Gerät weiter',
  'setup.count.cta': 'Gerät an Spieler 1 weitergeben',
  'setup.slot.player_label': 'Spieler {n}',
  'setup.slot.hint': 'Halten, um deinen Namen einzugeben',
  'setup.slot.welcome': 'Tippe deinen Namen',
  'setup.slot.name_placeholder': 'Dein Name',
  'setup.slot.confirm': 'Bestätigen — Gerät weitergeben',
  'setup.slot.duplicate_error': 'Dieser Name ist bereits vergeben.',

  'setup.players.heading': 'Spieler',
  'setup.players.hint': 'Trage jeden Spieler ein. Der erste Name ist der Gastgeber.',
  'setup.players.host_placeholder': 'Name des Gastgebers',
  'setup.players.player_placeholder': 'Spieler {index}',
  'setup.players.add': '+ Spieler hinzufügen',
  'setup.players.duplicate_error': 'Namen müssen eindeutig sein.',

  'setup.briefing.eyebrow': 'Vorbereitung',
  'setup.briefing.title': 'Lagebesprechung',
  'setup.briefing.settings': 'Einstellungen',
  'setup.host_settings.title': 'Raum-Einstellungen',
  'setup.host_settings.eyebrow': 'Host-Steuerung · Akte',
  'setup.host_settings.hint': 'Stell die Runde ein, bevor du austeilst. Nur der Host sieht das.',
  'setup.host_settings.lock_in': 'Bestätigen',
  'setup.host_settings.section.mode': 'Spielmodus',
  'setup.host_settings.section.roles': 'Rollen',
  'setup.host_settings.section.pace': 'Tempo',
  'setup.host_settings.section.word_pack': 'Wortpaket',
  'setup.host_settings.infiltre_hint': 'Lügt über ein ähnliches Wort',
  'setup.host_settings.clochard_label': 'Clochard einschließen',
  'setup.host_settings.clochard_hint':
    'Streuner aus dem Viertel. Weiß nichts. Kann den Sieg stehlen, indem er das Wort der Flics errät.',
  'setup.host_settings.timer_hint': 'Sekunden pro Runde · 0 = kein Timer',
  'setup.host_settings.timer_off': 'Aus',
  'category.animals': 'Tiere',
  'category.food': 'Essen',
  'category.objects': 'Objekte',
  'category.geography': 'Geografie',
  'category.nature': 'Natur',
  'category.sports': 'Sport',
  'category.movies': 'Filme',
  'category.slang': 'Slang',
  'setup.briefing.headline_top': 'Lage-',
  'setup.briefing.headline_bottom': 'besprechung.',
  'setup.briefing.lede':
    'Rekrutiere deine Verdächtigen. Tippe eine Polaroid zum Umbenennen. Wörter bleiben versiegelt — auch vor dem Host.',
  'setup.briefing.recruit': 'Rekrutieren',
  'setup.briefing.suspects': 'Verdächtige',
  'setup.briefing.need_more': 'Noch {needed} rekrutieren',
  'setup.briefing.deal_cards': 'Runde starten',
  'setup.briefing.sealed_hint': 'Wortpaar versteckt — auch vor dem Host.',
  'setup.mugshot.customize_aria': 'Porträt anpassen',
  'setup.mugshot.title': 'Phantombild',
  'setup.mugshot.phase': 'Akte 01',
  'setup.mugshot.subtitle': 'Verdächtiger erfasst',
  'setup.mugshot.section.identity': 'Identität',
  'setup.mugshot.section.features': 'Merkmale',
  'setup.mugshot.randomize': 'Zufällig',
  'setup.mugshot.close': 'Schließen',
  'setup.mugshot.done': 'Fertig',
  'setup.mugshot.category.menton': 'Kinn',
  'setup.mugshot.category.nez': 'Nase',
  'setup.mugshot.category.bouche': 'Mund',
  'setup.mugshot.category.moustache': 'Schnurrbart',
  'setup.mugshot.category.yeux': 'Augen',
  'setup.mugshot.category.sourcils': 'Augenbrauen',
  'setup.mugshot.category.cheveux': 'Haare',
  'setup.mugshot.category.accessoire': 'Accessoire',
  'setup.recruit.sealed_eyebrow': 'Versiegelt · nicht öffnen',

  'setup.options.heading': 'Optionen',
  'setup.options.include_clochard': 'Clochard einschließen',
  'setup.options.discussion_seconds': 'Diskussions-Timer',
  'setup.options.discussion_seconds_hint': 'Sekunden bis zur Abstimmung. 0 = manuell.',
  'setup.options.locale': 'Sprache',

  'locale.en': 'English',
  'locale.fr': 'Français',
  'locale.es': 'Español',
  'locale.de': 'Deutsch',
  'locale.pt': 'Português',

  'setup.start': 'Spiel starten',

  'play.no_active_game': 'Kein aktives Spiel.',
  'play.go_home': 'Zur Startseite',
  'play.connecting': 'Verbinde…',
  'play.phase_label': 'Phase: {phase}',

  'play.privacy_gate.pass_to': 'Weitergeben an',
  'play.privacy_gate.hold_to_reveal': 'Gedrückt halten zum Aufdecken',
  'play.privacy_gate.tap_to_reveal': 'Tippen zum Aufdecken',
  'play.privacy_gate.hold_to_see_word': 'Halten, um dein Wort zu sehen',
  'play.privacy_gate.tap_to_see_word': 'Tippen, um dein Wort zu sehen',
  'play.privacy_gate.hold_to_vote': 'Halten zum Abstimmen',
  'play.privacy_gate.done': 'Fertig — Gerät weitergeben',
  'play.pass_device.eyebrow': 'Gerät weitergeben an',
  'play.pass_device.dossier': 'Dossier · {n}/{total}',
  'play.pass_device.no_peeking': '— Nicht spähen. Die Wände haben Ohren.',
  'play.pass_device.ready': 'Ich bin bereit',

  'play.handoff.all_done_eyebrow': 'Alle Spieler fertig',
  'play.handoff.all_revealed_title': 'Alle Spieler bereit',
  'play.handoff.all_revealed_description': 'Zeit zu diskutieren. Sprecht der Reihe nach.',
  'play.handoff.continue': 'Weiter',
  'play.handoff.all_voted_title': 'Alle Stimmen abgegeben',
  'play.handoff.all_voted_description': 'Tippen, um aufzudecken.',
  'play.handoff.reveal': 'Aufdecken',

  'pause.button': 'Pause',
  'pause.eyebrow': 'Spiel pausiert · unter uns',
  'pause.title': 'Pause machen.',
  'pause.sub': 'Mach weiter oder zieh den Stecker.',
  'pause.resume.label': 'Weiter',
  'pause.resume.sub': 'Zurück zum Spiel.',
  'pause.rules.label': 'Spielregeln',
  'pause.rules.sub': 'Regeln nachsehen.',
  'pause.quit.label': 'Beenden',
  'pause.quit.sub': 'Spiel beenden. Einstellungen bleiben.',
  'pause.recap.label': 'Rundenrückblick',
  'pause.recap.sub': 'Schau die Akte an.',

  'recap.eyebrow_between': 'Akte · Runde geschlossen',
  'recap.eyebrow_end': 'Akte · vollständig',
  'recap.title_between': 'Rundenrückblick',
  'recap.title_end': 'So lief es ab',
  'recap.sub_between': 'Was bisher passiert ist. Nutze es. Oder nicht.',
  'recap.sub_end': 'Jede Runde, jeder Rauswurf, der Reihe nach.',
  'recap.empty': 'Noch keine Runden — Akte ist leer.',
  'recap.still_in_room': 'Noch im Raum',
  'recap.eliminated_meta': 'Raus · {count} übrig',
  'recap.round_short': 'Rd',
  'recap.close': 'Schließen',

  'round.your_role': 'Deine Rolle',
  'round.your_card': 'Deine Karte',
  'round.your_word': 'Dein Wort',
  'round.no_word': 'Kein Wort',
  'round.no_word_hint': 'Bluffe dich durch.',

  'round.speaking.heading': 'Sprechreihenfolge',
  'round.speaking.hint':
    'Jeder Spieler gibt der Reihe nach einen Hinweis. Sag das Wort nicht direkt.',
  'round.speaking.ready_to_vote': 'Bereit zur Abstimmung',
  'round.speaking.order_eyebrow': 'DER REIHE NACH',
  'round.speaking.order_title': 'Um den Tisch',

  'round.vote.eyebrow': '{name} — deine Stimme',
  'round.vote.heading': 'Schnapp den Infiltré',

  'round.result.eyebrow': 'Runde geschlossen',
  'round.result.complete_eyebrow': 'Akte',
  'round.result.voted_out_eyebrow': 'Rausgewählt',
  'play.clochard.spotlight': 'Im Rampenlicht',
  'play.clochard.last_words': '{name}, letzte Worte.',
  'play.clochard.one_guess': 'Ein Versuch',
  'round.result.cast_eyebrow': 'Besetzung enthüllt',
  'round.result.suspects_count': 'Verdächtige',
  'round.result.win_team.flic': 'FLICS',
  'round.result.win_team.infiltre': 'INFILTRÉS',
  'round.result.win_team.clochard': 'CLOCHARD',
  'round.result.win_verb.flic': 'GEWINNEN.',
  'round.result.win_verb.infiltre': 'GEWINNEN.',
  'round.result.win_verb.clochard': 'GEWINNT.',
  'round.result.sub_flic': '— der Tisch hat ihn enttarnt.',
  'round.result.sub_infiltre': '— direkt vor euren Augen.',
  'round.result.sub_clochard': '— ein Schuss. Eiskalt.',
  'round.result.replay_cta': 'Nochmal',
  'round.result.new_dossier_cta': 'Neue Akte',
  'round.result.title': 'Rundenergebnis',
  'round.result.title_finished': 'Spiel beendet',
  'round.result.still_in': 'Noch im Spiel',
  'round.eliminated': 'Ausgeschieden',
  'round.winner': 'Sieger',
  'round.case_closed': 'Fall gelöst',
  'round.flic_word': 'Wort der Flics',
  'round.infiltre_word': 'Wort der Infiltrés',
  'round.next_round': 'Nächste Runde',
  'round.back_home': 'Zurück zur Startseite',
  'round.result.view_case_log_one': 'Aktenprotokoll · 1 Runde',
  'round.result.view_case_log_many': 'Aktenprotokoll · {count} Runden',
  'round.rematch': 'Revanche',
  'round.replay.button': 'Noch eine Runde',
  'round.replay.waiting': 'Warten ({count}/{needed} bereit)',
  'round.replay.requested': 'Du willst weiterspielen',
  'round.eliminate.heading': 'Wer wurde rausgewählt?',
  'round.eliminate.eyebrow': 'Abstimmung',
  'round.eliminate.host_hint': 'Host · tippe den Verlierer',
  'round.eliminate.subtitle': 'Laute Abstimmung · am Tisch',
  'round.eliminate.body':
    'Jeder lebende Spieler zeigt auf jemanden, kein Zögern. Zähl die Hände am Tisch — der Host tippt den Verlierer.',
  'round.eliminate.cta_idle': 'Tippe einen Spieler',
  'round.eliminate.cta_picked': '{name} eliminieren',
  'round.speaking.rule_eyebrow': 'Regel der Runde',
  'round.speaking.rule_line1': 'Ein Wort.',
  'round.speaking.rule_line2': 'Keine Wiederholung.',
  'round.discuss.heading': 'Diskussion',
  'round.discuss.eyebrow_calm': 'Reden · beschuldigen · verteidigen',
  'round.discuss.eyebrow_danger': 'Zeit wird knapp',
  'round.discuss.seconds_label': 'Sekunden',
  'round.discuss.tick_calm.0': '„Wer blufft?“',
  'round.discuss.tick_calm.1': '„Glaub ich nicht.“',
  'round.discuss.tick_calm.2': '„Beweis es.“',
  'round.discuss.tick_calm.3': '„Du zuerst.“',
  'round.discuss.tick_hot.0': '„Zeit ist um.“',
  'round.discuss.tick_hot.1': '„Wähle.“',
  'round.discuss.tick_hot.2': '„Entscheide dich.“',

  'play.clochard.title': 'Clochard erwischt',
  'play.clochard.description': '{name}, errate das Wort der Flics, um zu gewinnen.',
  'play.clochard.placeholder': 'Dein Tipp',
  'play.clochard.submit': 'Tipp abgeben',

  'role.flic': 'Flic',
  'role.infiltre': 'Infiltré',
  'role.clochard': 'Clochard',

  'home.online_join.eyebrow': 'Online',
  'home.online_join.label': 'Beitreten',
  'home.online_join.description': 'Einladung erhalten? Code eintippen.',

  'home.discord.eyebrow': 'Sprachkanal · Activity',
  'home.discord.heading': 'Spielt mit eurem Kanal',
  'home.discord.tagline': 'Alle im Voice, eine gemeinsame Akte.',
  'home.discord.lede': 'Alle in diesem Sprachkanal landen in derselben Akte.',
  'home.discord.lede_named': 'Hey {name} — hol alle im Voice in dieselbe Akte.',
  'home.discord.start_activity': 'Activity-Raum betreten',
  'home.discord.start_busy': 'Akte wird geöffnet…',
  'home.discord.join_with_code': 'Anderen Raum mit Code beitreten',
  'home.discord.no_instance': 'Discord-Activity nicht erkannt — Activity neu starten.',
  'home.discord.sdk_failed': 'Discord-SDK konnte nicht starten. Erneut versuchen.',
  'home.discord.sdk_retry': 'Erneut versuchen',
  'home.discord.solo_label': 'Auf diesem Gerät spielen',
  'home.online.unavailable': 'Online-Modus nicht verfügbar — Server nicht erreichbar.',

  'online.create.eyebrow': 'Neue Akte',
  'online.create.heading': 'Raum erstellen',
  'online.create.hint': 'Wähle einen Namen. Wir erzeugen einen Code zum Teilen.',
  'online.create.name_placeholder': 'Dein Name',
  'online.create.submit': 'Raum erstellen',
  'online.create.creating': 'Erstelle…',

  'online.join.eyebrow': 'Briefing-Raum',
  'online.join.heading': 'Raum beitreten',
  'online.join.hint': 'Gib den Code ein, den dein Freund geteilt hat.',
  'online.join.name_placeholder': 'Dein Name',
  'online.join.code_placeholder': 'RAUMCODE',
  'online.join.submit': 'Beitreten',
  'online.join.joining': 'Verbinde…',

  'online.lobby.players': 'Spieler',
  'online.lobby.briefing_room': 'Lagebesprechung',
  'online.lobby.host_badge': 'Gastgeber',
  'online.lobby.you_badge': 'du',
  'online.lobby.reconnecting_badge': 'verbindet',
  'online.lobby.offline_badge': 'offline',
  'online.toast.room_not_found': 'Raum nicht gefunden',
  'online.toast.room_full': 'Raum voll',
  'online.toast.kicked_after_grace': 'Du warst zu lange getrennt',
  'online.toast.unauthorized': 'Sitzung abgelaufen',
  'online.toast.presence_online': '{name} ist wieder online',
  'online.toast.presence_reconnecting': '{name} verbindet sich neu',
  'online.toast.presence_offline': '{name} ist offline',
  'online.toast.server_error.actor_mismatch': 'Diese Aktion stammt nicht aus deiner Sitzung',
  'online.toast.server_error.unknown_player': 'Spieler nicht im Raum',
  'online.toast.server_error.name_required': 'Name darf nicht leer sein',
  'online.toast.server_error.invalid_message': 'Ungültige Anfrage',
  'online.toast.server_error.unauthorized': 'Nicht erlaubt',
  'online.toast.server_error.only_host': 'Nur der Gastgeber darf das',
  'online.toast.server_error.wrong_phase': 'Aktion zu spät — Runde ist weiter',
  'online.toast.server_error.invalid_target': 'Ungültiges Ziel',
  'online.toast.server_error.not_your_guess': 'Du bist nicht am Raten dran',
  'online.toast.server_error.not_a_member': 'Du bist nicht in diesem Raum',
  'online.toast.server_error.not_enough_players': 'Es fehlen Spieler',
  'online.toast.server_error.too_many_players': 'Zu viele Spieler',
  'online.toast.server_error.room_already_exists': 'Raum existiert bereits',
  'online.toast.server_error.no_session': 'Sitzung abgelaufen — Wiederverbindung',
  'online.toast.server_error.create_via_rest': 'Raum auf der Startseite erstellen',
  'online.toast.server_error.system_only_message': 'Systemnachricht blockiert',
  'online.toast.server_error.internal': 'Unerwarteter Serverfehler',
  'online.toast.server_error.generic': 'Serverfehler: {message}',
  'online.lobby.waiting_host': 'Warte darauf, dass der Gastgeber startet…',
  'online.lobby.start_game': 'Spiel starten',
  'online.lobby.need_more_players': 'Mindestens 3 Spieler erforderlich',

  'online.room.code_label': 'Raumcode',
  'online.room.code_hide': 'Code verbergen',
  'online.room.code_show': 'Code anzeigen',
  'online.room.copy': 'Kopieren',
  'online.room.copied': 'Kopiert!',

  'online.banner.connecting': 'Verbinde erneut…',
  'online.banner.error': 'Verbindung verloren. Erneuter Versuch.',

  'online.reveal.acknowledge': 'Verstanden',
  'online.reveal.waiting.eyebrow': 'PHASE 01 · BRIEFING',
  'online.reveal.waiting.title': 'Briefing läuft',
  'online.reveal.waiting.descriptor': '— warte auf {pending} Agent(en)',
  'online.reveal.waiting.center_label': 'bereit',
  'online.discuss.host_open_vote_button': 'Bereit zur Abstimmung',
  'online.discuss.waiting_host': 'Warte, bis der Gastgeber die Abstimmung öffnet…',
  'online.discuss.timer_label': 'Abstimmung in {time}',
  'online.discuss.timer_expired': 'Öffne Abstimmung…',
  'online.discuss.timer_eyebrow': 'Abstimmung in',
  'online.vote.spectating': 'Du bist ausgeschieden. Du schaust zu.',
  'online.vote.waiting.eyebrow': 'PHASE 03 · ABSTIMMUNG',
  'online.vote.waiting.title': 'Stimmen werden gezählt',
  'online.vote.waiting.descriptor': '— {pending} Stimme(n) ausstehend',
  'online.vote.waiting.center_label': 'gestimmt',
  'online.clochard.spectating': '{name} wagt den letzten Schuss.',
  'online.round.waiting_host': 'Warte auf den Gastgeber…',
  'online.spectator.heading': 'Zuschauer',
  'online.spectator.eyebrow': 'AUSSER GEFECHT · ZUSCHAUEN',
  'online.spectator.eliminated': 'Du bist raus — du schaust zu.',
  'online.spectator.finished': 'Spiel beendet.',
  'online.spectator.flic_word': 'Wort der Flics',
  'online.spectator.infiltre_word': 'Wort der Infiltrés',
  'online.spectator.phase_label': 'Phase: {phase}',
  'online.host_changed.banner': '{name} ist jetzt Gastgeber.',
  'online.host_changed.you_banner': 'Du bist jetzt Gastgeber.',

  'platform.error.discord_unavailable': 'Discord-Funktionen sind hier nicht verfügbar.',
  'platform.error.tauri_unavailable': 'Desktop-Funktionen sind hier nicht verfügbar.',
  'platform.error.capacitor_unavailable': 'Mobile Funktionen sind hier nicht verfügbar.',
  'platform.error.identity_failed': 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
  'platform.banner.platform_label': 'Läuft auf {platform}',
  'platform.discord.connecting': 'Verbinde mit Discord…',
  'platform.discord.authorizing': 'Discord-Autorisierung…',
  'platform.tauri.connecting': 'Lade Sitzung…',
  'platform.capacitor.connecting': 'Lade Sitzung…',
  'a11y.privacy_gate.aria_label': 'Halten zum Aufdecken — übergib an {name}',
  'a11y.vote_board.candidate_aria_label': 'Für {name} stimmen',
  'a11y.audio.mute_label': 'Soundeffekte stummschalten',
  'a11y.audio.unmute_label': 'Soundeffekte aktivieren',
  'a11y.audio.volume_label': 'Lautstärke der Effekte',

  'nav.brand': 'L’Infiltré',
  'nav.back': 'Zurück',
  'nav.home_label': 'Zur Startseite',
  'nav.settings_label': 'Einstellungen öffnen',

  'settings.title': 'Einstellungen',
  'settings.close': 'Schließen',
  'settings.section.language': 'Sprache',
  'settings.language.subtitle': 'wähle die Sprache der Oberfläche',
  'settings.section.theme': 'Thema',
  'settings.theme.noir': 'Noir',
  'settings.theme.party': 'Party',
  'settings.section.layout': 'Layout',
  'settings.layout.auto': 'Auto',
  'settings.layout.mobile': 'Mobil',
  'settings.layout.desktop': 'Desktop',
  'settings.section.audio': 'Audio',
  'settings.audio.mute': 'Soundeffekte stummschalten',
  'settings.audio.volume': 'Lautstärke',

  'mode.select.heading': 'Wähle einen Modus',
  'mode.select.hint': 'Wähle, wie ihr spielt. Lässt sich in den Einstellungen ändern.',
  'mode.select.coming_soon': 'Demnächst',
  'mode.infiltre_classic.name': 'L’Infiltré',
  'mode.infiltre_classic.tagline': 'Flics gegen Infiltrés. Finde, wer nicht passt.',
  'mode.team_deathmatch.name': 'Team-Deathmatch',
  'mode.team_deathmatch.tagline': 'Zwei Teams, zwei Wörter. Finde deine Verbündeten.',

  'briefing.phase_00': 'Phase 00 · Aufbau',
  'briefing.title': 'Briefing',
  'briefing.subtitle': 'richte den Tisch ein, bevor du austeilst',
  'briefing.mode.label': 'Modus — wähle einen',
  'briefing.mode.classic': '1 Infiltré · Standard',
  'briefing.mode.duo': '2 Infiltrés · 6+ Spieler',
  'briefing.mode.trio': '3 Infiltrés · 9+ Spieler',
  'briefing.mode.clochard': '+ Clochard · 5+ Spieler',
  'briefing.timer.label': 'Diskussion · Sekunden',
  'briefing.clochard.label': 'Clochard einschließen',
  'briefing.clochard.hint': '(Spieler ohne Wort)',
  'briefing.footer.ready': 'bereit — {count} Verdächtige',
  'briefing.footer.need_more': '{count} weitere Spieler nötig',
  'briefing.footer.deal': 'Austeilen',
  'briefing.tape.briefing_room': 'Briefing room',
  'briefing.tape.how_to_play_l1': 'wie',
  'briefing.tape.how_to_play_l2': 'spielen?',

  'round.distribution.phase_eyebrow': 'PHASE 01 · AUSGABE',
  'round.distribution.title': 'Ausgabe',
  'round.distribution.descriptor': '— {step} von {total}',
  'round.distribution.tour': 'RUNDE',
  'round.distribution.no_peeking_tape': 'NICHT SPÄHEN',
  'round.dossier.phase_eyebrow': 'PHASE 01 · PERSÖNLICHE AKTE',
  'round.dossier.title': 'Akte',
  'round.dossier.descriptor': '— Finger halten zum Lesen',
  'round.dossier.field_name': 'NAME',
  'round.dossier.field_role': 'ROLLE',
  'round.dossier.field_word': 'CODEWORT',
  'round.dossier.release_to_hide': '— loslassen zum Verbergen',
  'round.dossier.close_cta': 'AKTE SCHLIESSEN',
  'round.speaking.phase_eyebrow': 'PHASE 02 · WORTRUNDE',
  'round.speaking.descriptor': '— ein Wort, laut, der Reihe nach',
  'round.discuss.phase_eyebrow': 'PHASE 03 · OFFENE DEBATTE',
  'round.discuss.title': 'Debatte',
  'round.discuss.descriptor': '— wer lügt? sprecht es aus.',
  'round.discuss.timer_eyebrow': 'STOPPUHR · VERBLEIBEND',
  'round.discuss.timer_calm_sub': '— lass dir Zeit',
  'round.discuss.timer_danger_sub': '— die Zeit läuft',
  'round.discuss.suspects_pill': '{count} Verdächtige im Spiel',
  'round.vote.phase_eyebrow': 'PHASE 04 · ABSTIMMUNG AM TISCH',
  'round.vote.title': 'Wahl',
  'round.vote.descriptor': '— stimmt laut ab, markiert den Verlierer',
  'round.verdict.phase_eyebrow': 'PHASE 05 · URTEIL',
  'round.verdict.descriptor': '— der Verdächtige fällt',
  'round.verdict.role_revealed': 'ROLLE ENTHÜLLT',
  'round.verdict.role_tagline.flic': 'echtes Wort · unschuldig',
  'round.verdict.role_tagline.infiltre': 'falsches Wort · schuldig',
  'round.verdict.role_tagline.clochard': 'ohne Wort · Joker',
  'round.verdict.stamp': 'AUSGESCHIEDEN',
  'round.verdict.no_elimination.title': 'Kein Urteil',
  'round.verdict.no_elimination.stamp': 'AKTE VERTAGT',
  'round.verdict.no_elimination.descriptor': '— Stimmen geteilt, das Spiel geht weiter',
  'round.verdict.no_elimination.still_in': 'Noch im Spiel',
};
